// src/data/portfolioProjects.js

export const portfolioProjects = [
  {
    id: 1,
    title: "148 Clinton Street",
    category: "Custom Home",
    description: "Crafted with modern finishes and open layouts designed to maximize natural light. Our all-white kitchens feature custom cabinetry, Calacatta quartz countertops, Brizzo fixtures, and integrated Blomberg and Café appliances—including induction stoves and dishwashers. Bathrooms are fitted with wall-mounted toilets, custom vanities, and elegant tilework throughout.",
    location: "Brooklyn, NY",
    year: "2023",
    images: [
      "https://storage.googleapis.com/m1b_portfolio_photos/project%20photos/renovated/renovated/148-150_Clinton_-kitchen02-2-scaled.jpg",
      "https://storage.googleapis.com/m1b_portfolio_photos/project%20photos/renovated/renovated/Living-Dining-Room-scaled.jpg",
      "https://storage.googleapis.com/m1b_portfolio_photos/project%20photos/renovated/renovated/2N-Outdoor_staged_2-scaled.jpg"
    ],
    featured: true
  },
  {
    id: 2,
    title: "Bathroom",
    category: "Renovation",
    description: "Complete restoration of a 1960s architectural gem, preserving original elements while adding modern amenities and energy efficiency.",
    location: "Brooklyn, NY",
    year: "2024",
    images: [
      "https://storage.googleapis.com/m1b_portfolio_photos/project%20photos/renovated/renovated/27%20(1).jpeg",
      "https://storage.googleapis.com/m1b_portfolio_photos/project%20photos/renovated/renovated/356_bathroom.webp",
      "https://storage.googleapis.com/m1b_portfolio_photos/project%20photos/renovated/renovated/176-Atlantic-Ave_-2-2-1-scaled.jpg"

    ],
    featured: true
  },
  {
    id: 3,
    title: "356 West Basement Duplex",
    category: "Custom Home",
    description: "Transformed basement and ground floors into beautiful duplex units",
    location: "New York, NY",
    year: "2025",
    images: [
      "https://storage.googleapis.com/m1b_portfolio_photos/project%20photos/renovated/renovated/IMG_5852.JPG",
      "https://storage.googleapis.com/m1b_portfolio_photos/project%20photos/renovated/renovated/IMG_5841.JPG",
      "https://storage.googleapis.com/m1b_portfolio_photos/project%20photos/renovated/renovated/IMG_5830.JPG",
      "https://storage.googleapis.com/m1b_portfolio_photos/project%20photos/renovated/renovated/IMG_5844.JPG"
    ],
    featured: true
  },
  {
    id: 4,
    title: "Luxury Kitchen Remodel",
    category: "Renovation",
    description: "High-end kitchen renovation featuring custom cabinetry, marble countertops, and state-of-the-art appliances.",
    location: "Brooklyn, NY",
    year: "2022",
    images: [
      "https://storage.googleapis.com/m1b_portfolio_photos/project%20photos/renovated/renovated/09.jpeg",
      "https://storage.googleapis.com/m1b_portfolio_photos/project%20photos/renovated/renovated/176-Atlantic-Ave_-2-7-1-scaled.jpg"
    ],
    featured: false
  },
  {
    id: 5,
    title: "356 West 48",
    category: "Custom Home",
    description: "Each residence is the result of meticulous construction and attention to detail. Kitchens were built from the ground up with custom millwork for cabinetry, precisely installed stone countertops, and seamless integration of premium appliance systems. Structural adjustments were made to maximize space and utility, ensuring both form and function. Bathrooms were constructed with spa-grade waterproofing, precision tile setting, and high-end plumbing installations to support wall-mounted fixtures and floating vanities—delivering both durability and luxury",
    location: "Hells Kitchen, NY",
    year: "2024",
    images: [
      "https://storage.googleapis.com/m1b_portfolio_photos/project%20photos/renovated/renovated/356_living.webp",
      "https://storage.googleapis.com/m1b_portfolio_photos/project%20photos/renovated/renovated/356_bed.webp",
      "https://storage.googleapis.com/m1b_portfolio_photos/project%20photos/renovated/renovated/356_bathroom.webp",
      "https://storage.googleapis.com/m1b_portfolio_photos/project%20photos/renovated/renovated/356_facade.webp"
    ],
    featured: false
  },
  {
    id: 6,
    title: "Waterfront Office Complex",
    category: "Commercial",
    description: "A modern 80,000 sq ft office complex with sustainable design features, collaborative workspaces, and extensive amenities.",
    location: "Seattle, WA",
    year: "2021",
    images: [
      "https://images.unsplash.com/photo-1497366858526-0766cadbe8fa?...",
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?...",
      "https://images.unsplash.com/photo-1600566752355-35792bedcfea?..."
    ],
    featured: false
  }
];